import { ISignUpCrmBasicParams, ISignUpCrmParams, ISignUpCrmVerificationParams } from '@aqx-core/common/api/auth';
import { ECommonResponseCode } from '@aqx-core/common/request';

export enum ESignUpCrmContent {
  BASIC = 'BASIC',
  VERIFICATION = 'VERIFICATION',
  COMPLETE = 'COMPLETE'
}

export interface IRequestOtpParams {
  onSuccess: (timeoutInSec?: number, expiryTime?: number) => void;
  onError: (message: string, code: ECommonResponseCode) => void;
  isBasicInfoStep?: boolean;
}

export interface ICompleteBasicInfoStepParams extends IRequestOtpParams {
  basicInfo: ISignUpCrmBasicParams;
}

export interface ICompleteSignUpParams {
  params: ISignUpCrmVerificationParams;
  onError: (message: string) => void;
  onSuccess?: (params: ISignUpCrmParams) => void;
}
